/**
 * RepDrawer.js
 */

import $ from 'jquery';

export default class RepDrawer {

    constructor() {

        this.openButton = $('.open-drawer');
        this.innerDrawerBtn = $('.inner-drawer-rep-btn');
        this.closeButton = $('.close-drawer');
        this.openButton.on('click', (e)=> { this.openDrawer(e) });
        this.sampleMaterials = $('.sample-material-content');
        this.innerDrawerBtn.on('click', this.activateRep)
        this.closeButton.on('click', this.closeDrawer);
        this.sampleState = $('[data-sample-state]');
        this.sampleState.on('click', this.toggleSampleState);
        this.document = document;
        this.links = $('a[href]', '.rep-drawer');
        this.links.on('click', (evt) => this.repLink(evt) );


        $("a[href*='#contact']").on('click', function (){
            $('.nav-main .open-drawer.rep-view').trigger('click');
        });

        let anchor = location.hash;
        if(anchor == '#contact'){
            this.openButton.trigger('click');
        }

        $(document).on('keyup', (e) => this.closeNav(e));

    }

    repLink(evt) {
        if (evt.currentTarget.hash === '#contact-rep') {
            evt.preventDefault();

            this.activateRep();

        }
    }

    toggleSampleState() {
        $('body').removeClass('rep-active').addClass('sample-materials-active')
        $('.sample-material-content').removeClass('materials-active');
        $('.sample-material-content')[$(this).data('sample-state')].classList.add('materials-active');
    }

    openDrawer(e) {
        let focusableDrawerContent;
        if (e.target.classList.contains('rep-view')) {
            $('body').addClass(`open-drawer rep-active`).removeClass('sample-materials-active');
            focusableDrawerContent = $('.rep-content button, .rep-content [href], .rep-content input, .rep-content select, .rep-content textarea, .rep-content [tabindex]:not([tabindex="-1"])');
            $('#menu-close').on('keydown', (e)=> { this.tabToBottom(e, focusableDrawerContent.last()) });
            focusableDrawerContent.last().on('keydown', (e)=> { this.tabToTop(e) });
        } else {
            $('.sample-material-content').removeClass('materials-active');
            $('.sample-material-content')[$('.drawer-navigation').data('start')].classList.add('materials-active');
            $('body').addClass(`open-drawer sample-materials-active`);
            focusableDrawerContent = $('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', $('.sample-material-content')[$(e.target).data('current-program')]);
            $('#menu-close').on('keydown', (e)=> { this.tabToBottom(e, focusableDrawerContent.last()) });
            focusableDrawerContent.last().on('keydown', (e)=> { this.tabToTop(e) });
        }
        $('#menu-close').focus();
        $('#menu-close').on('keydown', (e)=> { this.tabToBottom(e, focusableDrawerContent.last()) });
    }

    tabToBottom(e, lastElement) {
        if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            lastElement.focus()
        }
    }

    tabToTop(e) {
        if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            $('#menu-close').focus();
        }
    }

    closeNav(e) {
        if (e.type === "keyup" && e.key !== "Escape") {
            return;
        }
        this.closeDrawer();
    }

    activateRep() {
        $('body').removeClass('sample-materials-active');
        $('body').addClass(`rep-active`);
        $('.rep-drawer').scrollTop(0)
    }

    closeDrawer() {
        $('.sample-material-content').each((_, el) => {
            $(el).removeClass('materials-active');
        })
        $('body').removeClass('open-drawer rep-active sample-materials-active');
    }

}
